'use es6';

import { removeSpanAndResetState } from './utils';
import throttle from 'hs-lodash/throttle';
import { autocompleteQuickInsertIsActiveAtom, updateAutocompleteEscaped, autocompleteActiveRangeAtom, autocompleteCommandIsActiveAtom, autocompleteResultPopoverIsActiveAtom } from '../data/autocompleteAtoms';
import { handleNavigationKeyDown, resetCommandSelectedOnEnter, getCommandWasSelectedOnEnter } from './navigationHandler';
import { getAtomValue } from '../data/atomUtils';
import handleAutocompleteCommandChange from './handleAutocompleteCommandChange';
import handleAutocompleteQuickInsertChange from './handleAutocompleteQuickInsertChange';
export default function addEventListeners(editor) {
  const onKeyUp = e => {
    return new Promise((resolve, reject) => {
      const commandTriggersMap = editor.autoCompleteCommands;
      const quickInsertTriggersMap = editor.autocompleteQuickInsertOptions;
      if (!commandTriggersMap && !quickInsertTriggersMap) {
        // Short circuit if the plugin is enabled, but no triggers have been added
        return resolve();
      }
      const keyPressed = e.key;
      if (getCommandWasSelectedOnEnter() && keyPressed === 'Enter') {
        // Bail early if our keydown listener told us that the enter key was pressed and a command was selected
        // That way, we don't open the autocomplete menu again
        resetCommandSelectedOnEnter();
        return resolve();
      }
      const autocompleteCommandIsActive = getAtomValue(autocompleteCommandIsActiveAtom);
      const autocompleteQuickInsertIsActive = getAtomValue(autocompleteQuickInsertIsActiveAtom);
      const inAutocompleteCommand = Boolean(commandTriggersMap[keyPressed]) && !autocompleteQuickInsertIsActive || autocompleteCommandIsActive;
      if (inAutocompleteCommand) {
        return handleAutocompleteCommandChange(editor, keyPressed).then(resolve).catch(reject);
      }
      return handleAutocompleteQuickInsertChange(editor).then(resolve).catch(reject);
    });
  };
  const throttledKeyUp = throttle(onKeyUp, 50);
  function checkIfSelectionRangeIsInGivenRange(rangeToCompare) {
    const selectionRange = editor.selection.getRng();
    const selectionRangeStartsAtOrAfterGivenRange = selectionRange.compareBoundaryPoints(Range.START_TO_START, rangeToCompare) >= 0;
    const selectionRangeEndsAtOrBeforeGivenRange = selectionRange.compareBoundaryPoints(Range.END_TO_END, rangeToCompare) <= 0;
    return selectionRangeStartsAtOrAfterGivenRange && selectionRangeEndsAtOrBeforeGivenRange;
  }
  const onNodeChange = e => {
    const commandsTriggerMap = editor.autoCompleteCommands;
    const quickInsertTriggersMap = editor.autocompleteQuickInsertOptions;
    if (!commandsTriggerMap && !quickInsertTriggersMap) {
      // Short circuit if the plugin is enabled, but no slash commands have been added
      return;
    }
    const autocompleteQuickInsertIsActive = getAtomValue(autocompleteQuickInsertIsActiveAtom);
    const autocompleteCommandActive = getAtomValue(autocompleteCommandIsActiveAtom);
    const autocompleteActiveRange = getAtomValue(autocompleteActiveRangeAtom);
    const autocompleteResultMenuIsOpen = getAtomValue(autocompleteResultPopoverIsActiveAtom);

    // If an autocomplete is active and we have an active range
    // check to see if we should remove our autocomplete menu
    if ((autocompleteQuickInsertIsActive || autocompleteCommandActive || autocompleteResultMenuIsOpen) && autocompleteActiveRange) {
      if (e.selectionChange) {
        // Short circuit, tinymce told us that the selected node has changed
        // so we can't still be focused on the same autocomplete menu
        removeSpanAndResetState(editor);
        return;
      }
      const currentSelectionIsInAutocompleteRange = checkIfSelectionRangeIsInGivenRange(autocompleteActiveRange);
      if (!currentSelectionIsInAutocompleteRange) {
        removeSpanAndResetState(editor);
      }
    }
  };
  editor.on('NodeChange', onNodeChange);
  editor.on('focus', () => {
    updateAutocompleteEscaped(false);
  });
  editor.on('keyup', throttledKeyUp);
  editor.on('keydown', e => {
    handleNavigationKeyDown(e, editor);
  });
}